<template>
  <div class="content-container" ref="animationSection">
    <!-- Animated paragraph -->
    <!-- <p class="mb-8 text-left" v-html="animatedParagraphHtml"></p> -->
    <p class="mb-8 text-center px-4">
      Become part of a visionary software engineering company committed to innovation, quality, and delivering
      outstanding solutions. Here's why you should consider being part of our team.
    </p>

    <!-- Animated list items -->
    <!-- <ul
      class="list-disc marker:text-[#A64BE4] marker:border marker:border-white marker:text-xl pl-6 ml-2 grid grid-cols-2 gap-4 mt-16 text-left">
      <li v-for="(item, index) in listItems" :key="`list-item-${index}`" class="transition-opacity duration-500"
        :class="visibleListItems[index] ? 'opacity-100' : 'opacity-0'">
        {{ item.text }}
      </li>
    </ul> -->
    <ul
      class="list-disc marker:text-[#501D71] marker:border marker:border-white marker:text-xl pl-6 lg:ml-2 grid sm:grid-cols-2 gap-y-4 gap-x-8 mt-12 text-left max-w-max mx-auto">
      <li>Culture of Collaboration</li>
      <li>Innovation at the Core</li>
      <li>Unlimited Growth Opportunity</li>
      <li>Empowering Work Environment</li>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const paragraphText =
  "Become a part of a visionalry software engineering company committed to innovation, quality, and delivering outstading solutions. Here's why you should consider being part of our team."
const paragraphWords = paragraphText.split(' ')
const visibleParagraphWords = ref(0)

const listItems = [
  { text: 'Collaborate with a team' },
  { text: 'Work on exciting projects' },
  { text: 'Gain valuable experience' },
  { text: 'Join a company' }
]
const visibleListItems = ref(listItems.map(() => false))

const WORD_DELAY = 100
const SENTENCE_DELAY = 500

const isInView = ref(false)
const animationSection = ref(null)
let observer = null
let animationStarted = false

const animatedParagraphHtml = computed(() => {
  return paragraphWords
    .map((word, i) => {
      if (visibleParagraphWords.value >= i + 1) {
        if (word === 'visionalry') {
          return `<span class="relative">${word}</span>`
        }
        return word
      }
      return ''
    })
    .join(' ')
})

const animateParagraph = async () => {
  for (let i = 0; i < paragraphWords.length; i++) {
    if (!isInView.value) return
    visibleParagraphWords.value = i + 1
    await new Promise((resolve) => setTimeout(resolve, WORD_DELAY))
  }

  await new Promise((resolve) => setTimeout(resolve, SENTENCE_DELAY))
  if (isInView.value) animateList()
}

const animateList = async () => {
  for (let i = 0; i < listItems.length; i++) {
    if (!isInView.value) return
    visibleListItems.value[i] = true
    await new Promise((resolve) => setTimeout(resolve, SENTENCE_DELAY / 2))
  }
}

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0]
      isInView.value = entry.isIntersecting

      if (isInView.value && !animationStarted) {
        animationStarted = true
        animateParagraph()
      }
    },
    {
      threshold: 0.2
    }
  )

  if (animationSection.value) {
    observer.observe(animationSection.value)
  }
})

onUnmounted(() => {
  if (observer && animationSection.value) {
    observer.unobserve(animationSection.value)
  }
})
</script>